module.exports = __webpack_public_path__ + "img/NO.a42b6b09.svg";